import Barcode from 'react-barcode'

import LabelCard from '../LabelCard'
import { GrupoLogo } from 'assets/icons'
import useOrderStore from 'store/client/orderStore'
import { ReactComponent as MySVG4 } from '../../../../../assets/deneme60x402.svg'

import React, { useRef, useEffect } from 'react';

export default function Page1({ sizeData, selectColor = 0, barcodeValue, data }) {
  const { referance } = useOrderStore()
  const isBlack = referance?.backgroundColor === 'B'

  const barcodeRef = useRef(null);

  useEffect(() => {
    const svgElement = barcodeRef.current?.querySelector('svg');
    const textElement = svgElement?.querySelector('text');
    if (textElement) {
      textElement.style.fill = isBlack ? 'white' : '';
      textElement.style.transform = 'translate(-1px, 1.2px)';
      textElement.style.letterSpacing = '2.7px'; // harf aralığı
    }
    if (svgElement) {
      svgElement.style.display = 'block';
      svgElement.style.verticalAlign = 'top';
    }
  }, [barcodeValue, isBlack]);

  return (
    <div  className="flex flex-wrap gap-3">
      <LabelCard type="front" number={1}>
        <div className="h-full pl-[4.5mm] pt-[9mm] pr-[5.5mm]">
        {isBlack && (
          <div
            style={{
              backgroundColor: 'white',
              height: 23,
              width: 185.7,
              position: 'absolute',
              top: 42,
              left: 6,
            }}
          />
        )}
          <div className="flex justify-center w-full">
            {isBlack && <div className="h-[19px] w-3 mt-[1px]" />}
            <div className="inline-flex w-fit max-w-full flex-col">
              <div ref={barcodeRef} className="inline-flex flex-col leading-none gap-0 [&_svg]:block" style={{marginTop:7,marginLeft:-6.4}} >
                <Barcode
                  value={barcodeValue?.length === 13 ? barcodeValue : '0390547180002'}
                  format="ITF14"
                  width={1.29   }
                  height={22.7}
                  marginLeft={1}
                  marginRight={1}
                  marginTop={1}
                  marginBottom={0}
                  textMargin={0}
                  background="transparent"
                  lineColor={isBlack ? '#000000' : '#000000'}
                  fontSize={12}
                  font="Arial"
                />
              </div>
              <div
                className="helveregular text-[7pt]"
                style={{
                  display: 'grid',
                  gridTemplateColumns: '1fr 1fr',
                  gridTemplateRows: 'auto auto auto',
                  rowGap: 0,
                  width: '100%',
                  marginTop: '0.5px',
                  lineHeight: 1,
                }}
              >
                <p
                  className="m-0 p-0 whitespace-nowrap"
                  style={{
                    gridColumn: 1,
                    gridRow: 1,
                    justifySelf: 'start',
                    color: isBlack ? '#FFFFFF' : '#000000',
                    marginLeft:-5.2,
                    marginTop :-0.08,
                    transform: 'translate(0.3px, -0.2px)',
                  }}
                >
                {`${data?.articleNo || 'N/A'}/${data?.washingLabel?.[selectColor]?.colorCode || 'N/A'}/${sizeData?.name || 'N/A'}`}
                </p>
                <p
                  className="m-0 p-0 whitespace-nowrap text-right"
                  style={{
                    gridColumn: 2,
                    gridRow: 1,
                    justifySelf: 'end',
                    color: isBlack ? '#FFFFFF' : '#000000',
               
                    marginTop:-0.08,
                    marginRight:-7,
                    minWidth:50,
                    transform: 'translate(0px, -0.2px)',

                  }}
                >
                 {sizeData?.cn || 'N/A'}
               
                </p>
                <p
                  className="m-0 p-0 whitespace-nowrap"
                  style={{ gridColumn: 1, gridRow: 2, justifySelf: 'start', marginTop: '0.92mm',marginLeft:-5.2,                    transform: 'translate(0.3px, -0.2px)',
                  }}
                >
                  RUC 80089348-4
                </p>
                <p
                  className="m-0 p-0 whitespace-nowrap text-right"
                  style={{ gridColumn: 2, gridRow: 2, justifySelf: 'end', marginTop: '0.92mm',marginRight:-7.1 }}
                >
                  RN 77302
                </p>
                <div
                  style={{
                    gridColumn: '1 / -1',
                    gridRow: 3,
                    display: 'flex',
                    alignItems: 'flex-end',
                    justifyContent: 'space-between',
                    width: '100%',
                    marginTop: '1.8mm',
                    paddingTop: '1mm',
                  }}
                >
                  <div
                    className="m-0 p-0 [&_svg]:block [&_svg]:h-auto [&_svg]:w-full"
                    style={{
                      width: '22.580mm',
           
                      flexShrink: 0,
                      marginLeft:-2.9,
                      transform: 'translate(-1.6px, 1.3px)',
                    }}
                  >
                    <GrupoLogo />
                  </div>
                  <p
                    className="m-0 p-0 whitespace-nowrap"
                    style={{
                      paddingBottom: '0.5px',
                      marginRight: -8.5,
                      marginTop:1.8,
                      paddingTop:1.5,
                      transform: 'translate(-1.8px, 1.4px)',
                      letterSpacing: '-0.10px',
                    }}
                  >
                    zara.com/contact
                  </p>
                </div>
              </div>
            </div>
            {isBlack && <div className="h-[19px] w-3 mt-[1px]" />}
          </div>
        </div>
      </LabelCard>
      <LabelCard type="back" number={2}>
        <div className="flex items-center h-full">
          <div className="scale-y-[158.7%] scale-x-[94%] leading-[4.5pt] pl-[2.5mm]">
            <p>INDITEX,S.A. AV. DIPUTACION ED.INDITEX ARTEIXO</p>
            <p>A CORUÑA (SPAIN) C.I.F. A-15075062</p>
            <p>TEXMODA S.A.S SIC 900.123.408 TAC</p>
            <p>
              ARGENTINA S.A. CUIT:30-69314836-3 V-
              {data?.country?.code || 'N/A'}-21
            </p>
            <p>AZKA LOGISTICS LLC, TEXTILES ZANZIBAR S.A.</p>
            <p>RIF:N°J30536946-1 REG.NO:0000051 TI-02</p>
            <p>MACROMODA S.A. RUC 1792159105001 ZARA</p>
            <p>BRASIL LTDA. CNPJ:02952485000491 ZARA CANADA</p>
            <p>INC.CA 36685 아이티엑스코리아 자라코리아 서울시</p>
            <p>강남구 삼성동 E 20080-479-0880</p>
            <p>MA-MAROC: Sté AZZURRO IF: 1641920</p>
            <p>(株)ITXジャパン 03-6415-8061</p>
            <p className="text-[4.5pt]">
              IMPORTADO POR ZARA MEXICO, S.A. DE C.V. PONIENTE 146 NO. 730 COLONIA INDUSTRIAL
              VALLEJO ALCALDIA AZCAPOTZALCO, C.P. 02300, CIUDAD DE MEXICO, RFC:ZME920824KM3
            </p>
          </div>
        </div>
      </LabelCard>
    </div>
  )
}
